// extracted by mini-css-extract-plugin
module.exports = {"title":"CategoriesGifts_title__1x7GV","button":"CategoriesGifts_button__1kl49","gift-photo":"CategoriesGifts_gift-photo__2y4Xz"};